import React from 'react';
import {View} from 'react-native';
import {GetHolderProfileCabinetResponsePayload, GetProfileSettingsResponsePayload} from '../../../shared/models/api';
import Screen from '../../../shared/components/screen';
import {useStyles as useStylesHook} from '../../../shared/hooks/styles';
import {ProfileInfo} from './components/profileInfo';
import {ContentWithRightImageDesktopProfile} from './components/contentWithRightImageDesktopProfile';
import {CardInfo} from '../../../shared/components/cardInfo';

interface IProps {
  holderProfile: GetHolderProfileCabinetResponsePayload | null;
  profileSettings: GetProfileSettingsResponsePayload | null;
}

export default ({holderProfile}: IProps) => {
  const styles = useStylesHook(({theme}) => {
    return {
      container: {
        marginHorizontal: 60,
        marginTop: 31,
      },
      h2: {
        ...theme.fonts.h2,
      },
    };
  });

  return (
    <Screen>
      <View testID='profile-desktop-container-id' style={styles.container}>
        <ContentWithRightImageDesktopProfile
          icon={<CardInfo />}
          hideImage={true}
          contentStyle={{minHeight: 'auto'}}
          btnTitle='Привязать аккаунт'
          btnType='linkedAccountInput'>
          <ProfileInfo profile={holderProfile} />
        </ContentWithRightImageDesktopProfile>
      </View>
    </Screen>
  );
};
